/*  ========================================================================
    # Hooks - Use SVG Sprite
    ========================================================================  */

/**
 * Hook to get the SVG sprite.
 */
const useSVGSprite = () => {
  return (window as any).svgSprite || '';
};

export default useSVGSprite;
